'use client';

import { PropsWithChildren } from 'react';

import { Preloader } from '../Preloader/Preloader';
import NotAllowedCountry from './NotAllowedCountry';
import { useClientLocale } from '@/hooks';

type ContryContentFilterProps = {
  isBot: boolean;
};

export default function ContryContentFilter({
  isBot,
  children,
}: PropsWithChildren<ContryContentFilterProps>) {
  //TODO ASAP Rework to backend logic!
  const { isServiceBlocked, isLoading } = useClientLocale();

  if (isBot) return children;
  //if (isLoading) return <Preloader />;

  return (
    <>
      {isLoading ? <Preloader /> : null}
      {isServiceBlocked ? <NotAllowedCountry /> : children}
    </>
  );
}
